var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect, useState } from "react";
import { Create, DateTimeInput, SimpleForm, useGetOne, useNotify, useRefresh, } from "react-admin";
import { useTranslation } from "react-i18next";
import { CircularProgress, FormControl, InputLabel, MenuItem, Select, TextField, Typography, } from "@mui/material";
import { useMutation } from "@apollo/client";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { MANAGE_ELECTION_DATES } from "@/queries/ManageElectionDates";
import { IPermissions } from "@/types/keycloak";
import SelectElection from "@/components/election/SelectElection";
export var EventProcessors;
(function (EventProcessors) {
    EventProcessors["ALLOW_INIT_REPORT"] = "ALLOW_INIT_REPORT";
    EventProcessors["START_VOTING_PERIOD"] = "START_VOTING_PERIOD";
    EventProcessors["END_VOTING_PERIOD"] = "END_VOTING_PERIOD";
    EventProcessors["ALLOW_VOTING_PERIOD_END"] = "ALLOW_VOTING_PERIOD_END";
    EventProcessors["START_ENROLLMENT_PERIOD"] = "START_ENROLLMENT_PERIOD";
    EventProcessors["END_ENROLLMENT_PERIOD"] = "END_ENROLLMENT_PERIOD";
    EventProcessors["START_LOCKDOWN_PERIOD"] = "START_LOCKDOWN_PERIOD";
    EventProcessors["END_LOCKDOWN_PERIOD"] = "END_LOCKDOWN_PERIOD";
    EventProcessors["ALLOW_TALLY"] = "ALLOW_TALLY";
})(EventProcessors || (EventProcessors = {}));
var CreateEvent = function (_a) {
    var _b, _c, _d, _e;
    var electionEventId = _a.electionEventId, setIsOpenDrawer = _a.setIsOpenDrawer, isEditEvent = _a.isEditEvent, selectedEventId = _a.selectedEventId, getElectionName = _a.getElectionName;
    var t = useTranslation().t;
    var _f = useState(false), isLoading = _f[0], setIsLoading = _f[1];
    var refresh = useRefresh();
    var tenantId = useTenantStore()[0];
    var _g = useGetOne("sequent_backend_scheduled_event", { id: selectedEventId }, { enabled: !!selectedEventId }), selectedEvent = _g.data, refetch = _g.refetch;
    var notify = useNotify();
    var manageElectionDates = useMutation(MANAGE_ELECTION_DATES, {
        context: {
            headers: {
                "x-hasura-role": IPermissions.SCHEDULED_EVENT_WRITE,
            },
        },
    })[0];
    var _h = useState(isEditEvent ? selectedEvent === null || selectedEvent === void 0 ? void 0 : selectedEvent.event_payload.election_id : null), electionId = _h[0], setElectionId = _h[1];
    var _j = useState(isEditEvent ? selectedEvent === null || selectedEvent === void 0 ? void 0 : selectedEvent.cron_config.scheduled_date : null), scheduleDate = _j[0], setScheduleDate = _j[1];
    var _k = useState(isEditEvent
        ? (_b = selectedEvent === null || selectedEvent === void 0 ? void 0 : selectedEvent.event_processor) !== null && _b !== void 0 ? _b : EventProcessors.START_VOTING_PERIOD
        : EventProcessors.START_VOTING_PERIOD), eventType = _k[0], setEventType = _k[1];
    useEffect(function () {
        var _a;
        if (isEditEvent) {
            refetch();
            setEventType((_a = selectedEvent === null || selectedEvent === void 0 ? void 0 : selectedEvent.event_processor) !== null && _a !== void 0 ? _a : EventProcessors.START_VOTING_PERIOD);
        }
    }, [isEditEvent]);
    useEffect(function () {
        var _a, _b;
        if (selectedEventId &&
            isEditEvent &&
            !electionId &&
            ((_a = selectedEvent === null || selectedEvent === void 0 ? void 0 : selectedEvent.event_payload) === null || _a === void 0 ? void 0 : _a.election_id)) {
            setElectionId((_b = selectedEvent === null || selectedEvent === void 0 ? void 0 : selectedEvent.event_payload) === null || _b === void 0 ? void 0 : _b.election_id);
        }
    }, [electionId, isEditEvent, (_c = selectedEvent === null || selectedEvent === void 0 ? void 0 : selectedEvent.event_payload) === null || _c === void 0 ? void 0 : _c.election_id, selectedEventId]);
    var targetsElection = function (event_processor) {
        switch (event_processor) {
            case EventProcessors.ALLOW_INIT_REPORT:
            case EventProcessors.START_VOTING_PERIOD:
            case EventProcessors.END_VOTING_PERIOD:
            case EventProcessors.ALLOW_VOTING_PERIOD_END:
            case EventProcessors.ALLOW_TALLY:
                return true;
            case EventProcessors.START_ENROLLMENT_PERIOD:
            case EventProcessors.END_ENROLLMENT_PERIOD:
            case EventProcessors.START_LOCKDOWN_PERIOD:
            case EventProcessors.END_LOCKDOWN_PERIOD:
                return false;
        }
    };
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var variables, _a, data, errors, error_1;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setIsLoading(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    variables = {
                        electionEventId: electionEventId,
                        electionId: targetsElection(eventType) &&
                            electionId &&
                            electionId.length > 0
                            ? electionId
                            : null,
                        scheduledDate: scheduleDate,
                        eventProcessor: eventType,
                    };
                    return [4 /*yield*/, manageElectionDates({
                            variables: variables,
                        })];
                case 2:
                    _a = _c.sent(), data = _a.data, errors = _a.errors;
                    setIsLoading(false);
                    setIsOpenDrawer(false);
                    refresh();
                    if (((_b = data === null || data === void 0 ? void 0 : data.manage_election_dates) === null || _b === void 0 ? void 0 : _b.error_msg) || errors) {
                        notify(t("eventsScreen.messages.createError"), { type: "error" });
                    }
                    else {
                        notify(t("eventsScreen.messages.editSuccess"), { type: "success" });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _c.sent();
                    console.error(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var isRequiredElection = function (eventType) {
        return ![EventProcessors.START_VOTING_PERIOD, EventProcessors.END_VOTING_PERIOD].includes(eventType);
    };
    var userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return (_jsx(Create, __assign({ hasEdit: isEditEvent }, { children: _jsxs(SimpleForm, __assign({ onSubmit: onSubmit }, { children: [_jsx(Typography, __assign({ variant: "h4" }, { children: t("".concat(isEditEvent ? "eventsScreen.edit.title" : "eventsScreen.create.title")) })), _jsx(Typography, __assign({ variant: "body2" }, { children: t("".concat(isEditEvent
                        ? "eventsScreen.edit.subtitle"
                        : "eventsScreen.create.subtitle")) })), _jsxs(FormControl, __assign({ fullWidth: true }, { children: [_jsx(InputLabel, __assign({ id: "event-type-select-label" }, { children: t("eventsScreen.eventType.label") })), _jsxs(Select, __assign({ required: true, name: "event_type", labelId: "event-type-select-label", label: t("eventsScreen.eventType.label"), value: eventType, onChange: function (e) { return setEventType(e.target.value); }, disabled: isEditEvent || isLoading }, { children: [_jsx(MenuItem, __assign({ value: EventProcessors.ALLOW_INIT_REPORT }, { children: t("eventsScreen.eventType.ALLOW_INIT_REPORT") })), _jsx(MenuItem, __assign({ value: EventProcessors.START_VOTING_PERIOD }, { children: t("eventsScreen.eventType.START_VOTING_PERIOD") })), _jsx(MenuItem, __assign({ value: EventProcessors.END_VOTING_PERIOD }, { children: t("eventsScreen.eventType.END_VOTING_PERIOD") })), _jsx(MenuItem, __assign({ value: EventProcessors.ALLOW_VOTING_PERIOD_END }, { children: t("eventsScreen.eventType.ALLOW_VOTING_PERIOD_END") })), _jsx(MenuItem, __assign({ value: EventProcessors.START_ENROLLMENT_PERIOD }, { children: t("eventsScreen.eventType.START_ENROLLMENT_PERIOD") })), _jsx(MenuItem, __assign({ value: EventProcessors.END_ENROLLMENT_PERIOD }, { children: t("eventsScreen.eventType.END_ENROLLMENT_PERIOD") })), _jsx(MenuItem, __assign({ value: EventProcessors.START_LOCKDOWN_PERIOD }, { children: t("eventsScreen.eventType.START_LOCKDOWN_PERIOD") })), _jsx(MenuItem, __assign({ value: EventProcessors.END_LOCKDOWN_PERIOD }, { children: t("eventsScreen.eventType.END_LOCKDOWN_PERIOD") })), _jsx(MenuItem, __assign({ value: EventProcessors.ALLOW_TALLY }, { children: t("eventsScreen.eventType.ALLOW_TALLY") }))] }))] })), _jsx(FormControl, __assign({ fullWidth: true }, { children: isEditEvent ? (_jsx(TextField, { label: t("eventsScreen.election.label"), disabled: true, value: selectedEvent ? getElectionName(selectedEvent) : "-" })) : (targetsElection(eventType) && (_jsx(SelectElection, { isRequired: isRequiredElection(eventType), tenantId: tenantId, electionEventId: electionEventId, label: t("eventsScreen.election.label"), onSelectElection: function (electionId) { return setElectionId(electionId); }, source: "event_payload.election_id", disabled: isEditEvent || isLoading, value: electionId }))) })), _jsx(DateTimeInput, { required: true, disabled: isLoading, source: "cron_config.scheduled_date", label: eventType === EventProcessors.START_VOTING_PERIOD
                        ? t("electionScreen.field.startDateTimeWithTimezone", {
                            timezone: userTimeZone,
                        })
                        : t("electionScreen.field.endDateTimeWithTimezone", {
                            timezone: userTimeZone,
                        }), defaultValue: isEditEvent
                        ? (_d = selectedEvent === null || selectedEvent === void 0 ? void 0 : selectedEvent.cron_config) === null || _d === void 0 ? void 0 : _d.scheduled_date
                        : scheduleDate, value: isEditEvent
                        ? (_e = selectedEvent === null || selectedEvent === void 0 ? void 0 : selectedEvent.cron_config) === null || _e === void 0 ? void 0 : _e.scheduled_date
                        : scheduleDate, parse: function (value) { return value && new Date(value).toISOString(); }, onChange: function (value) {
                        setScheduleDate(value && value.target.value !== ""
                            ? new Date(value.target.value).toISOString()
                            : undefined);
                    } }), isLoading ? _jsx(CircularProgress, {}) : null] })) })));
};
export default CreateEvent;
